@let count = notificationsCount();

<ui-button
	(buttonClicked)="toggleNotifications()"
	type="blue"
	[inverted]="count === 0"
	[uiBadge]="count > 0 ? count.toString() : ''"
	class="inline-block"
	[icon]="count > 0 ? 'bell_ring' : 'bell'"
	data-cy="notification-button"
></ui-button>
